// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import { buildRowActionsRendererDefinition, getColumnsToRender } from 'hooks/datatable';
import { rowClickBuilder } from 'hooks/profileActions';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import DataTable from 'UI/components/organisms/DataTable';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { useDataTableStyles } from 'UI/globalStyles/DataTableStyles';
import { SvgArrowLeft } from 'UI/res';

import { useStyles } from '../styles';
import { COLUMNS_DUPLICATE_TABLE } from '../utils';

interface SendoutDuplicatesProps {
  data: Array;
  title: string;
  subtitle: string;
  onNavigation: () => void;
  onClose: () => void;
  onBack: () => void;
}

const SendoutDuplicates = ({
  data,
  title,
  subtitle,
  onNavigation,
  onClose,
  onBack
}: SendoutDuplicatesProps) => {
  const dataTableClasses = useDataTableStyles();
  const classes = useStyles();

  const handleAction = async itemId => {
    if (!itemId) return;
    onNavigation && onNavigation(itemId);
  };

  const actionButton = buildRowActionsRendererDefinition({
    actions: [
      {
        name: 'view',
        onClick: rowClickBuilder({
          columns: COLUMNS_DUPLICATE_TABLE,
          data,
          pickId: true,
          callback: handleAction
        })
      }
    ]
  });

  const finalColumns = getColumnsToRender([...COLUMNS_DUPLICATE_TABLE, actionButton]);

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.close,
        variant: 'outlined',
        onClick: onClose
      },
      GridItemProps: {
        md: 3
      }
    },
    {
      props: {
        text: strings.shared.ui.goBack,
        variant: 'contained',
        onClick: onBack
      }
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true, onClose }}
      hasPaddingContent={false}
      CardHeaderProps={{
        title,
        titleTypographyProps: {
          variant: 'h5'
        },
        avatar: (
          <FPIconButton
            onClick={onBack}
            iconMode="custom"
            icon={SvgArrowLeft}
            family="mini"
            tooltipProps={{ title: 'Back' }}
          />
        )
      }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <Grid item className={classes.subtitleContainer} xs={12}>
        <Alert severity="info">
          <FPHtmlViewer content={subtitle} />
        </Alert>
      </Grid>

      <DataTable
        columns={finalColumns}
        data={data}
        sort
        isServerSide={false}
        filter={false}
        search={false}
        elevation={0}
        pagination={false}
        selectableRowsHeader={false}
        selectableRows="none"
        className={clsx(classes.tableClasses, dataTableClasses.withoutToolbar)}
      />
    </FPDrawer>
  );
};

export default SendoutDuplicates;
